// Pendiente de revisar
import i18n from "@/i18n/i18n";
import { ItiBaseDto } from "@/iti-core-react/dtos/iti-base-dto";
import { AutomationStatus } from "../enums/automation-status";
import { ProtocolType } from "../enums/protocol-type";
import { ConsolidationDto } from "./consolidation-dto";
import { IExecutionData } from "./execution-data";
import { StatusDto } from "./status-dto";

interface IConsolidationDto {
	fileType: string;
	fieldDelimiter: string;
	decimalDelimiter: string;
	resourceName: string;
	consolidation: ConsolidationDto;
}

interface ISourceConfiguration {
	sourceType: string;
	url: string;
	port: number;
	user: string;
	password: string;
	schema?: string;
	database?: string;
	topic: string;
	dataDictionary: any;
	ownerEmail?: string;
	ownerId?: string;
	structuredDistributionId?: string;
	skipKpiProfiling?: boolean;
	consolidation?: IConsolidationDto;
	executionData?: IExecutionData;
}

export class AutomationDto extends ItiBaseDto {
	public sourceConfiguration: ISourceConfiguration;
	public sessionName: string;
	public datasetId: string;
	public creationUserEmail: string;
	public datasetName: string;
	public organizationName: string;
	public createdDate: string;
	public status: StatusDto;
	public sessionId: string;
	public startNow = false;
	public statusMessage: string;
	public sessionDescription: string;
	public description: string;

	constructor(src?: any) {
		super(src);
		Object.assign(this, src);

		if (src) {
			this.sourceConfiguration = {
				sourceType: src.sourceConfiguration?.sourceType || ProtocolType.MQTT,
				url: src?.sourceConfiguration?.url,
				port: src?.sourceConfiguration?.port,
				user: src?.sourceConfiguration?.user,
				password: src?.sourceConfiguration?.password,
				schema: src?.sourceConfiguration?.schema,
				database: src?.sourceConfiguration?.database,
				topic: src?.sourceConfiguration?.topic,
				dataDictionary: src?.sourceConfiguration?.dataDictionary,
				ownerEmail: src?.sourceConfiguration?.ownerEmail,
				ownerId: src?.sourceConfiguration?.ownerId,
				structuredDistributionId:
					src?.sourceConfiguration?.structuredDistributionId,
				skipKpiProfiling: src?.sourceConfiguration?.skipKpiProfiling,
				consolidation: {
					fileType: src?.sourceConfiguration?.consolidation?.fileType || "",
					fieldDelimiter:
						src?.sourceConfiguration?.consolidation?.fieldDelimiter || "",
					decimalDelimiter:
						src?.sourceConfiguration?.consolidation?.decimalDelimiter || "",
					resourceName:
						src?.sourceConfiguration?.consolidation?.resourceName || "",
					consolidation: new ConsolidationDto(
						src?.sourceConfiguration?.consolidation?.consolidation || {
							type: "",
							value: "",
						},
					),
				},
				executionData: src?.sourceConfiguration?.executionData
					? {
							ruleId: src.sourceConfiguration.executionData.ruleId,
							eventId: src.sourceConfiguration.executionData.eventId,
							profile: src.sourceConfiguration.executionData.profile,
							createdAt: src.sourceConfiguration.executionData.createdAt,
							createdBy: src.sourceConfiguration.executionData.createdBy,
							datasetId: src.sourceConfiguration.executionData.datasetId,
							userEmail: src.sourceConfiguration.executionData.userEmail,
							columnName: src.sourceConfiguration.executionData.columnName,
							conditions: src.sourceConfiguration.executionData.conditions,
							metricName: src.sourceConfiguration.executionData.metricName,
							datasetName: src.sourceConfiguration.executionData.datasetName,
							logicalOperator:
								src.sourceConfiguration.executionData.logicalOperator,
							resourceDataType:
								src.sourceConfiguration.executionData.resourceDataType,
							structuredDistributionId:
								src.sourceConfiguration.executionData.structuredDistributionId,
							structuredDistributionName:
								src.sourceConfiguration.executionData
									.structuredDistributionName,
						}
					: undefined,
			};
		} else {
			this.sourceConfiguration = {
				sourceType: ProtocolType.MQTT,
				url: "",
				port: 0,
				user: "",
				password: "",
				schema: "",
				database: "",
				topic: "",
				dataDictionary: [],
				ownerEmail: "",
				ownerId: "",
				structuredDistributionId: "",
				consolidation: {
					fileType: "",
					fieldDelimiter: "",
					decimalDelimiter: "",
					resourceName: "",
					consolidation: new ConsolidationDto({
						type: "",
						value: "",
					}),
				},
			};
		}
	}

	// Mapeo de valores del enumerado a sus claves correspondientes
	private getStatusKey(status: AutomationStatus): string {
		switch (status) {
			case AutomationStatus.PENDING:
				return "pending";
			case AutomationStatus.STARTED:
				return "started";
			case AutomationStatus.PAUSED:
				return "paused";
			case AutomationStatus.FINISHED:
				return "finished";
			case AutomationStatus.DELETED:
				return "deleted";
			default:
				return "error";
		}
	}

	public get translatedStatus(): string {
		const statusKey = this.getStatusKey(this.status.code as AutomationStatus);
		return i18n.t(`automation.status.${statusKey}`);
	}
}
